import { useMemo } from 'react';
import useVariants from 'personalization-lib/hooks/variants/useVariants';
const useStrategyDefaultAsset = (strategyId, assetId) => {
  const {
    variants,
    loading,
    error: variantsError
  } = useVariants(strategyId);
  const defaultAsset = variants.at(-1);
  const isDefaultAsset = (defaultAsset === null || defaultAsset === void 0 ? void 0 : defaultAsset.assetCoordinates.id.toString()) === (assetId === null || assetId === void 0 ? void 0 : assetId.toString());
  const defaultNotFoundError = useMemo(() => strategyId && !isDefaultAsset && !(defaultAsset !== null && defaultAsset !== void 0 && defaultAsset.assetData) && !loading ? new Error('Default asset not found') : undefined, [strategyId, defaultAsset === null || defaultAsset === void 0 ? void 0 : defaultAsset.assetData, loading, isDefaultAsset]);
  const error = variantsError || defaultNotFoundError;
  return useMemo(() => ({
    defaultAsset,
    loading,
    error
  }), [defaultAsset, loading, error]);
};
export default useStrategyDefaultAsset;